// extracted by mini-css-extract-plugin
export default {"header":"DocumentsTableHead_header__32uB-","header_button":"DocumentsTableHead_header_button__dsFN5"};